module.exports = __webpack_public_path__ + "img/185.95c44207.svg";